import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './leaderboardNameModal.css';

interface LeaderboardNameModalProps {
  open: boolean;
  score: number;
  defaultName: string;
  isSubmitting: boolean;
  error: string | null;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

function LeaderboardNameModal({
  open,
  score,
  defaultName,
  isSubmitting,
  error,
  onSubmit,
  onCancel,
}: LeaderboardNameModalProps) {
  const { t } = useTranslation();
  const [name, setName] = useState(defaultName);

  useEffect(() => {
    if (open) {
      setName(defaultName);
    }
  }, [defaultName, open]);

  if (!open) {
    return null;
  }

  return (
    <div className="leaderboard-name-backdrop">
      <div className="leaderboard-name-modal">
        <h3>{t('leaderboardModal.title')}</h3>
        <p className="leaderboard-score">{t('leaderboardModal.scoreLabel')}: {score}</p>
        <p className="leaderboard-help">{t('leaderboardModal.help')}</p>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={8}
          autoFocus
          disabled={isSubmitting}
          className="leaderboard-name-input"
          placeholder={t('leaderboardModal.placeholder')}
        />
        {error && <p className="leaderboard-error">{t(error)}</p>}
        <div className="leaderboard-name-actions">
          <button onClick={onCancel} className="leaderboard-name-btn secondary" disabled={isSubmitting}>
            {t('leaderboardModal.skip')}
          </button>
          <button onClick={() => onSubmit(name)} className="leaderboard-name-btn" disabled={isSubmitting}>
            {isSubmitting ? t('leaderboardModal.saving') : t('leaderboardModal.submit')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LeaderboardNameModal;
